
const ConversionAPI: React.FC = () => {
  return (
    <div className="node-body">
      <div>
        <span className="font-label">Select conversion type</span>
        <select>
          <option>Lead</option>
          <option>Purchase</option>
        </select>
      </div>
      <div>
        <span className="font-label">Select conversion type</span>
        <select>
          <option>INR</option>
          <option>PND</option>
        </select>
      </div>
      <div>
        <span className="font-label">Enter Amount (optional)</span>
        <input placeholder="Type amount..." />
      </div>
    </div>
  );
}

export default ConversionAPI;
